/* The prev / next pair — KANON `Cwiczenia` 17.09.2026, `2-karta.html#e`'s `.k-nav`.
 *
 * `fixed` and centred on the viewport's own middle, which is where the panel is centred too. The
 * mock positions them `absolute` inside its 1512 frame; this app portals the dialog into `<body>`,
 * where `absolute` would resolve against the initial containing block and scroll away with the page.
 *
 * The centring is a translate and that is safe here, unlike the day modal's: this box is never
 * class-swapped, so nothing animates the transform out from under it.
 *
 * Every text leaf states its line-height. */

.walk {
  position: fixed;
  top: 50%;
  z-index: 20;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  align-items: center;
  width: var(--w-ex-theatre-walk);
  transform: translateY(-50%);
}

/* Centred in the gutter the panel leaves: half the gutter, less half the column's own width. */
.previous {
  left: calc((var(--w-ex-theatre-gutter) - var(--w-ex-theatre-walk)) / 2);
}

.next {
  right: calc((var(--w-ex-theatre-gutter) - var(--w-ex-theatre-walk)) / 2);
}

/* GEOMETRY for `shared/ui/ghostButton` — the treatment is that file's, and nothing is on both
 * sides. The fill is `--bg-card` rather than transparent: this square stands on a blurred scrim
 * over the list, and an unfilled outline there reads as a hole rather than a control. */
.square {
  justify-content: center;
  width: var(--sz-ex-theatre-walk);
  height: var(--sz-ex-theatre-walk);
  padding: var(--space-0);
  background: var(--bg-card);
  border-radius: var(--radius-12px);
}

.glyph {
  display: block;
  width: 20px;
  height: 20px;
}

/* On the SCRIM, not on a surface — so the ink is the scrim's own ramp rather than a theme's text
 * colour, in both themes, for the reason every scrim in this app states: the ground underneath is a
 * dimmed screenshot of the list and is dark in Flame and in Flame Dark alike.
 *
 * Two lines and then clipped: a three-line caption on the longest movement in the catalogue would
 * grow this column past the squares and unbalance the pair. */
.caption {
  display: -webkit-box;
  width: 100%;
  overflow: hidden;
  font-size: var(--fs-label);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-normal);
  color: var(--text-on-scrim);
  text-align: center;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
